import React, { Component } from 'react';
const API_URL = window.location.host.includes('localhost') ? 'http://localhost:3001' : 'https://enigmatic-shelf-39065.herokuapp.com';

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            password: '',
            confirmPassword: '',
            formMode: 'login',
            firstName: '',
            lastName: '',
            pageErrors: false,
            shouldVerify: false,
            verifySent: false,
        };
        this.handleButtonClick = this.handleButtonClick.bind(this);
    }

    componentWillMount() {
        const token = localStorage.getItem('id_token');
        if (token && token !== undefined) {
            return this.props.history.push('/home');
        }
        
        const hash = window.location.hash;
        if (Boolean(hash) && hash.split("#")[1].includes("reset")) {
            const eid = hash.split("eid=")[1];
            const iv = hash.split("iv=")[1]
            this.setState({ formMode: 'reset', eid, iv });
        }
        if (Boolean(hash) && hash.split("#")[1].includes("locked")) {
            this.setState({ shouldVerify: true });
        }
        if (Boolean(hash) && hash.split("#")[1].includes("verify")) {
            const eid = hash.split("eid=")[1];
            const iv = hash.split("iv=")[1];
            this.setState({ formMode: 'verifying', eid, iv });
            fetch(`${API_URL}/api/users/verify-cb?eid=${eid}&iv=${iv}`)
                .then(resp => resp.json())
                .then(json => {
                    if (json.message === 'success') {
                        this.setState({ 'formMode': 'login'})
                        alert("Your email address has been verified");
                    }
                })
                .catch(err => console.log(err));
        }
    }

    async componentWillReceiveProps(newProps) {
        const { currentUser } = newProps;

        if (!Boolean(currentUser)) {
            return;
        }

        if (!this.props.currentUser && !this.props.currentUser && currentUser.passwordUpdated) {
            this.setState({ formMode: 'login' });
            return alert("Password successfully reset.");
        }

        if (!this.props.currentUser && currentUser.passwordResetSent) {
            return alert("Check your email for a password reset email");
        }

        if (currentUser.message && currentUser.message !== null) {
            const message = await currentUser.message.json().then(json => json.message);
            if (message.includes("Please check your email to verify your account.")) {
                this.setState({ shouldVerify: false, verifySent: true });
            }
            alert(message);
            return false;
        }

        if (currentUser !== null) {
            localStorage.setItem('id_token', currentUser.id_token);
            localStorage.setItem('user', JSON.stringify(currentUser.user));
            newProps.history.push('/home');
        }
    }

    handleInput(key, value) {
        this.setState({ [key]: value });
    }

    handleLogin() {
        const { email, password } = this.state;
        this.props.login({ email, password });
    }

    handleKeyUp(e) {
        if (e.keyCode === 13) {
            this.state.formMode === 'login' ? this.handleLogin() : this.handleCreateAccount();
        }
    }

    toggleFormMode() {
        const newState = this.state.formMode === 'login' ? 'create' : 'login';
        this.setState({formMode: newState});
    }

    handleCreateAccount() {
        const { email, password, confirmPassword, firstName, lastName } = this.state;

        if (password !== confirmPassword) {
            return alert('Passwords must be the same');
        }

        if (!email || !password || !confirmPassword || !firstName || !lastName) {
            this.setState({ pageErrors: true });
            return alert('Please fill out all fields');
        }

        this.props.createAccount({ email, password, firstName, lastName });
    }

    handleResetPassword() {
        if (!this.state.email) {
            this.setState({ pageErrors: true });
            return alert('Please enter the email address you used to sign up');
        }
        this.props.resetPassword(this.state.email);
    }

    updatePassword() {
        const { password, confirmPassword, eid, iv } = this.state;
        if (password !== confirmPassword) {
            return alert('Passwords must be the same');
        }
        if (!password) {
            this.setState({ pageErrors: true });
            return alert('Please fill out all fields');
        }
        if (!Boolean(eid) && !Boolean(iv)) {
            return alert('There was an issue with your password reset. Please click the link in your email again.');
        }
        this.props.updatePassword(password, eid, iv);
    }

    handleButtonClick() {
        const { formMode } = this.state;
        if (formMode === 'login') {
            this.handleLogin();
        } else if (formMode === 'create') {
            this.handleCreateAccount();
        } else if (formMode === 'forgotPassword') {
            this.handleResetPassword();
        } else if (formMode === 'reset') {
            this.updatePassword();
        }
    }

    sendVerificationEmail() {
        const { email } = this.state;
        this.props.sendVerificationEmail(email);
        this.setState({ shouldVerify: false });
        alert(`Sent verification email to ${email}`);
    }

    render() {
        const buttonText = {
            'login': 'Login',
            'create': 'Create account',
            'forgotPassword': 'Reset password',
            'reset': 'Save new password',
        }[this.state.formMode];
        const {
            formMode,
            pageErrors,
            email,
            password,
            confirmPassword,
            firstName,
            lastName,
            shouldVerify,
            verifySent,
        } = this.state;

        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-200">
                <div className="w-full max-w-md p-3" >
                    <form action="" className=" bg-white shadow-md rounded px-8 py-8 pt-8">
                        {formMode !== 'verifying' &&
                            <img className="mb-8 mx-auto block" style={{height:120}} src={require('../assets/WestRoom.png')} alt="West Cancer Spark"/>
                        }
                        {formMode === 'verifying' ?
                            <div className="text-center font-bold text-gray-800">Verifying your email address...</div>
                            :
                            <div>
                                {verifySent &&
                                    <div className="text-red-600 mb-4 font-bold text-center">Check your email for a verification link</div>
                                }
                                {shouldVerify &&
                                    <div className="text-red-600 mb-4 font-bold text-center">Your account needs to be verified. Please enter your email and password below to have a verification email sent to you.</div>
                                }
                                {formMode === 'create' &&
                                    <div>
                                        <div className="pb-4">
                                            <label htmlFor="firstName" className="text-sm block font-bold pb-2 text-gray-700">FIRST NAME</label>
                                            <input
                                                onKeyUp={e => this.handleKeyUp(e)}
                                                onChange={e => this.handleInput('firstName', e.target.value)}
                                                type="text"
                                                name="firstName"
                                                id=""
                                                className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${pageErrors && firstName === '' ? 'border-red-600' : 'border-blue-300'}`}
                                                placeholder="Jane"/>
                                        </div>
                                        <div className="pb-4">
                                            <label htmlFor="lastName" className="text-sm block font-bold pb-2 text-gray-700">LAST NAME</label>
                                            <input onKeyUp={e => this.handleKeyUp(e)} onChange={e => this.handleInput('lastName', e.target.value)} type="text" name="lastName" id="" className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${pageErrors && lastName === '' ? 'border-red-600' : 'border-blue-300'}`} placeholder="Smith"/>
                                        </div>
                                    </div>
                                }
                                {formMode !== 'reset' &&
                                    <div className="pb-4">
                                        <label htmlFor="email" className="text-sm block font-bold pb-2 text-gray-700">EMAIL ADDRESS</label>
                                        <input onKeyUp={e => this.handleKeyUp(e)} onChange={e => this.handleInput('email', e.target.value)} type="email" name="email" id="" className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${pageErrors && email === '' ? 'border-red-600' : 'border-blue-300'}`} placeholder="name@westclinic.com"/>
                                    </div>
                                }
                                {formMode !== 'forgotPassword' &&
                                    <div className="pb-4">
                                        <label htmlFor="password" className="text-sm block font-bold pb-2  text-gray-700">PASSWORD</label>
                                        <input onKeyUp={e => this.handleKeyUp(e)} onChange={e => this.handleInput('password', e.target.value)} type="password" name="password" id="" className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${pageErrors && password === '' ? 'border-red-600' : 'border-blue-300'}`} placeholder="**********"/>
                                    </div>
                                }
                                {(formMode === 'create' || formMode === 'reset') && 
                                    <div className="pb-4">
                                        <label htmlFor="confirmPassword" className="text-sm block font-bold pb-2  text-gray-700">CONFIRM PASSWORD</label>
                                        <input onKeyUp={e => this.handleKeyUp(e)} onChange={e => this.handleInput('confirmPassword', e.target.value)} type="password" name="confirmPassword" className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${pageErrors && confirmPassword === '' ? 'border-red-600' : 'border-blue-300'}`} placeholder="**********"/>
                                    </div>
                                }
                                <div>
                                    <button onClick={this.handleButtonClick} className="bg-west-green text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full" type="button">{buttonText}</button>
                                    {formMode !== 'reset' &&
                                        <div>
                                            <div
                                                onClick={() => this.setState({ formMode: this.state.formMode === 'create' ? 'login' : 'create' })}
                                                className="cursor-pointer text-sm text-blue-400 underline text-center mt-4">
                                                {this.state.formMode === 'create' ? 'Login' : 'Create an account'}
                                            </div>
                                            <div
                                                onClick={() => this.setState({ formMode: 'forgotPassword' })}
                                                className="cursor-pointer text-sm text-blue-400 underline text-center mt-4">
                                                Forgot password?
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        }
                    </form>
                </div>
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/app.js